import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../history';
import PropTypes from 'prop-types';
import {
Route,
Switch,
Redirect
} from 'react-router-dom';
import QuizQuestionView from './QuizQuestionView.jsx';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

class Quiz extends Component {
	static propTypes = {
		quiz: PropTypes.object.isRequired
	};

	constructor(props)
	{
		super(props);

		if(cookies.get('key') !== "3fcfa1d9178290b9fc5404c6603b96ab") {
			history.push(`/`);
		}
	}

	render() {
		const { quiz } = this.props;

		//new
		const quizQuestionNew = `/quiz/:questionID`;
		const quizStartUrl = `/quiz/1`;

		if (!quiz) return null;
		return (
			<div className='quiz'>
				<Switch>
					<Route path={quizQuestionNew} component={QuizQuestionView} />
					<Redirect to={quizStartUrl} />
				</Switch>
			</div>
		);
	}
}

function mapStateToProps( { quiz }, { match: { params } }) {
	return {
		quiz
	};
}

export default connect(mapStateToProps)(Quiz);


// WEBPACK FOOTER //
// ./src/views/QuizView.jsx